export interface TourStep {
  id: string;
  target: string; // CSS selector or data-tour attribute
  title: string;
  content: string;
  placement: 'top' | 'bottom' | 'left' | 'right' | 'center';
  navigateTo?: string; // Optional route to navigate to before showing step
}

export const INDIVIDUAL_USER_TOUR: TourStep[] = [
  {
    id: 'welcome',
    target: 'body',
    title: 'Welcome to VoiceThera!',
    content: 'Let us show you around. This quick tour will help you get the most out of your personalized wellness experience.',
    placement: 'center',
  },
  {
    id: 'sidebar',
    target: '[data-tour="sidebar"]',
    title: 'Navigation Sidebar',
    content: 'This is your navigation hub. Access all features, categories, and your personal library from here.',
    placement: 'right',
  },
  {
    id: 'categories',
    target: '[data-tour="categories"]',
    title: 'Wellness Categories',
    content: 'Choose from various wellness categories like Meditation, Sleep, Anxiety Relief, and more. Each category offers sessions tailored to your needs.',
    placement: 'right',
  },
  {
    id: 'library',
    target: '[data-tour="library"]',
    title: 'Your Library',
    content: 'Access your sessions, groups, biographies, and audio gifts here. Everything you create is saved in your library.',
    placement: 'right',
  },
  {
    id: 'help',
    target: '[data-tour="help-link"]',
    title: 'Help & Support',
    content: 'Need assistance? Find detailed guides, FAQs, and demo videos in the Help section.',
    placement: 'right',
  },
  {
    id: 'settings',
    target: '[data-tour="settings-link"]',
    title: 'Settings',
    content: 'Customize your experience, manage your account, and view your credits in Settings.',
    placement: 'right',
  },
  {
    id: 'profile',
    target: '[data-tour="profile-link"]',
    title: 'Your Profile',
    content: 'Click here to access your profile and manage your personal biography for better personalization.',
    placement: 'top',
  },
  {
    id: 'complete',
    target: 'body',
    title: 'You\'re All Set!',
    content: 'You\'re ready to start your wellness journey. Try creating your first personalized session by selecting a category. You can restart this tour anytime from the Help section.',
    placement: 'center',
  },
];

export const TOUR_ID = 'individual-user-tour';
export const TOUR_VERSION = 1;
